import {Column, Text} from '@wonderlandengine/react-ui/components';
import {useEffect, useState} from 'react';

import {CoinButton} from '../components/coin-button.js';
import {StoreManager} from '../../components/store-manager.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {buyItem} from '../utils/buyItem.js';
import {Align, Justify} from '@wonderlandengine/react-ui';

export const BuyButton = (props: {stat: TransactionalNames; costIndex: number}) => {
    const [cost, setCost] = useState(0);
    const [amountLabel, setAmountLabel] = useState('');
    const [amount, setAmount] = useState(0);

    const buy = () => {
        buyItem(props.stat, cost, amount);
    };

    useEffect(() => {
        const coinCost = StoreManager.instance.getInventoryCost(
            props.stat,
            props.costIndex
        );
        setCost(coinCost);

        const inventoryAmountAdded = StoreManager.instance.getAmountToAdd(
            props.stat,
            props.costIndex
        );
        setAmount(inventoryAmountAdded);
        setAmountLabel('+' + inventoryAmountAdded);
    }, [props.stat, props.costIndex]);

    return (
        <Column rowGap={5} justifyContent={Justify.Center} alignItems={Align.Center}>
            <Text height={36} textAlign="center" fontSize={36}>
                {amountLabel}
            </Text>
            <CoinButton onClick={buy} price={cost} />
        </Column>
    );
};
